import e, { useRef as t } from "react";
import { FaCheckCircle as a, FaExclamationTriangle as l, FaTimesCircle as r, FaChevronLeft as n, FaChevronRight as s } from "react-icons/fa";
import { __rest as o, __assign as i, __read as c } from "tslib";
import m from "classnames";
import { FontAwesomeIcon as d } from "@fortawesome/react-fontawesome";
import { faChartBar as u, faArrowUp as p, faAward as x } from "@fortawesome/free-solid-svg-icons";
import f from "popper.js";

var v = function v(t) {
  var n = t.icon,
      s = t.variant,
      o = t.closeCallback,
      i = t.children;
  return e.createElement("div", {
    className: "text-white px-6 py-4 border-0 rounded relative mb-4 bg-" + s + "-500"
  }, n && e.createElement("span", {
    className: "text-xl inline-block mr-5 align-middle"
  }, "success" === n && e.createElement(a, null), "warning" === n && e.createElement(l, null), "error" === n && e.createElement(r, null)), e.createElement("span", {
    className: "inline-block align-middle mr-8"
  }, i), e.createElement("button", {
    className: "absolute bg-transparent text-2xl font-semibold leading-none right-0 top-0 mt-4 mr-6 outline-none focus:outline-none",
    onClick: function onClick(e) {
      return o && o(e);
    }
  }, e.createElement("span", null, "×")));
};

v.defaultProps = {
  variant: "green",
  closeCallback: function closeCallback(e) {
    console.log("clicking close button");
  }
};

var b = function b(t) {
  var a,
      l = t.rounded,
      r = t.variant,
      n = t.outline,
      s = t.size,
      c = t.uppercase,
      d = t.children,
      u = t.className,
      p = o(t, ["rounded", "variant", "outline", "size", "uppercase", "children", "className"]),
      x = m("text-white", "outline-none", "focus:outline-none", "font-bold", "shadow", "hover:shadow-md", ((a = {
    uppercase: c,
    "rounded-full": l,
    rounded: !l
  })["text-xs px-4 py-2"] = "sm" === s, a["text-sm px-6 py-3"] = "md" === s, a["text-base px-8 py-3"] = "lg" === s, a["bg-trasparent"] = n, a["border border-solid border-" + r + "-500"] = n, a["hover:bg-" + r + "-500 active:bg-" + r + "-600"] = n, a["text-" + r + "-500"] = n, a["hover:text-white active:text-white"] = n, a["bg-" + r + "-500 active:bg-" + r + "-600"] = !n, a));
  return e.createElement("button", i({
    type: "button",
    className: u + " " + x,
    style: {
      transition: "all .15s ease 0s"
    }
  }, p), d);
};

b.defaultProps = {
  rounded: !1,
  variant: "gray",
  outline: !1,
  size: "md",
  uppercase: !0
};

var g = function g(t) {
  var a = t.title,
      l = t.statistic,
      r = t.differenceProps,
      n = t.iconProps;
  return e.createElement("div", {
    className: "w-full lg:w-6/12 xl:w-3/12 px-4"
  }, e.createElement("div", {
    className: "relative flex flex-col min-w-0 break-words bg-white rounded mb-6 xl:mb-0 shadow-lg"
  }, e.createElement("div", {
    className: "flex-auto p-4"
  }, e.createElement("div", {
    className: "flex flex-wrap"
  }, e.createElement("div", {
    className: "relative w-full pr-4 max-w-full flex-grow flex-1"
  }, e.createElement("h5", {
    className: "text-gray-500 uppercase font-bold text-xs"
  }, a), e.createElement("span", {
    className: "font-semibold text-xl text-gray-800"
  }, l)), e.createElement(w, i({}, n))), e.createElement(E, i({}, r)))));
};

g.defaultProps = {
  title: "New users",
  statistic: "302,144"
};

var w = function w(t) {
  var a = t.iconProps,
      l = t.variant;
  return e.createElement("div", {
    className: "relative w-auto pl-4 flex-initial"
  }, e.createElement("div", {
    className: "text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full bg-" + l + "-500"
  }, a && e.createElement(d, i({}, a))));
};

w.defaultProps = {
  variant: "red",
  iconProps: {
    icon: u
  }
};

var E = function E(t) {
  var a = t.iconProps,
      l = t.statistic,
      r = t.statisticText,
      n = t.statisticColour;
  return e.createElement("p", {
    className: "text-sm text-gray-500 mt-4"
  }, e.createElement("span", {
    className: "text-" + n + "-500 mr-2"
  }, a && e.createElement(d, i({}, a)), l), e.createElement("span", {
    className: "whitespace-no-wrap"
  }, r));
};

E.defaultProps = {
  iconProps: {
    icon: p
  },
  statistic: "3.69%",
  statisticText: "This month",
  statisticColour: "green"
};

var h = Object.freeze({
  __proto__: null,
  Block: g,
  BlockIcon: w,
  BlockDifference: E
}),
    N = function N(a) {
  var l = a.items,
      r = c(e.useState(!1), 2),
      n = r[0],
      s = r[1],
      o = t(null),
      m = e.useRef(null);
  return e.createElement(e.Fragment, null, e.createElement("div", {
    className: "flex flex-wrap"
  }, e.createElement("div", {
    className: "w-full sm:w-6/12 md:w-4/12 px-4"
  }, e.createElement("div", {
    className: "relative inline-flex align-middle w-full"
  }, e.createElement("button", {
    className: "text-white font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 bg-gray-800",
    style: {
      transition: "all .15s ease"
    },
    type: "button",
    ref: o,
    onClick: function onClick() {
      n ? s(!1) : (new f(o.current, m.current, {
        placement: "bottom-start"
      }), s(!0));
    }
  }, "Toggle Dropdown"), e.createElement("div", {
    ref: m,
    className: (n ? "block " : "hidden ") + "bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg mt-1",
    style: {
      minWidth: "12rem"
    }
  }, null == l ? void 0 : l.map(function (t, a) {
    return e.createElement("a", i({
      key: a,
      className: "text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800",
      onClick: function onClick(e) {
        return e.preventDefault();
      }
    }, t));
  }))))));
},
    y = function y(t) {
  var a = t.title,
      l = t.leadingText,
      r = t.columns,
      n = t.bottomNavProps,
      s = t.socials;
  return e.createElement("footer", {
    className: "relative bg-gray-300 pt-8 pb-6"
  }, e.createElement("div", {
    className: "bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20",
    style: {
      height: "80px",
      transform: "translateZ(0px)"
    }
  }, e.createElement("svg", {
    className: "absolute bottom-0 overflow-hidden",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    version: "1.1",
    viewBox: "0 0 2560 100",
    x: "0",
    y: "0"
  }, e.createElement("polygon", {
    className: "text-gray-300 fill-current",
    points: "2560 0 2560 100 0 100"
  }))), e.createElement("div", {
    className: "container mx-auto px-4"
  }, e.createElement("div", {
    className: "flex flex-wrap"
  }, e.createElement("div", {
    className: "w-full md:w-6/12 px-4"
  }, a && e.createElement("h4", {
    className: "text-3xl font-semibold"
  }, a), l && e.createElement("h5", {
    className: "text-lg mt-0 mb-2 text-gray-700"
  }, l), e.createElement("div", {
    className: "mt-6"
  }, null == s ? void 0 : s.map(function (t, a) {
    var l;
    return e.createElement("a", i({
      key: a,
      href: (null === (l = t.linkProps) || void 0 === l ? void 0 : l.href) || "#",
      className: "bg-white text-" + (t.iconColour || "blue-400") + " shadow-lg font-lg p-3 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2 inline-block text-center leading-none"
    }, t.linkProps), t.iconProps && e.createElement(d, i({}, t.iconProps)));
  }))), e.createElement("div", {
    className: "w-full md:w-6/12 px-4"
  }, e.createElement("div", {
    className: "flex flex-wrap items-top mb-6"
  }, null == r ? void 0 : r.map(function (t, a) {
    var l;
    return e.createElement("div", {
      key: a,
      className: "w-full md:w-6/12 xl:w-4/12 pt-6 md:pt-0 md:px-4 ml-auto"
    }, e.createElement("span", {
      className: "block uppercase text-gray-600 text-sm font-semibold mb-2"
    }, t.heading), e.createElement("ul", {
      className: "list-unstyled"
    }, null === (l = t.items) || void 0 === l ? void 0 : l.map(function (t, a) {
      return e.createElement("li", {
        key: a
      }, e.createElement("a", i({
        className: "text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
      }, t.linkProps), t.text));
    })));
  })))), e.createElement(k, i({}, n))));
};

y.defaultProps = {
  copyrightName: "Rixcy"
};

var k = function k(t) {
  var a = t.copyrightName,
      l = t.copyrightLinkProps;
  return e.createElement(e.Fragment, null, e.createElement("hr", {
    className: "my-6 border-gray-400"
  }), e.createElement("div", {
    className: "flex flex-wrap items-center md:justify-between justify-center"
  }, e.createElement("div", {
    className: "w-full md:w-4/12 px-4 mx-auto text-center"
  }, e.createElement("div", {
    className: "text-sm text-gray-600 font-semibold py-1"
  }, "Copyright © ", new Date().getFullYear(), " ", e.createElement("a", i({}, l), a)))));
};

k.defaultProps = {
  copyrightName: "Rixcy",
  copyrightLinkProps: {
    href: "https://rixcy.website",
    target: "_blank"
  }
};

var P = function P(t) {
  var a = t.logo,
      l = t.logoLink,
      r = t.fixed,
      n = t.menuItems,
      s = r ? "top-0 fixed z-50" : null,
      o = "uppercase text-gray-800 hover:text-gray-600";
  return e.createElement("header", {
    className: "w-full bg-white flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg shadow-lg " + s
  }, e.createElement("div", {
    className: "container px-4 mx-auto flex flex-wrap items-center justify-between"
  }, e.createElement("a", i({}, l, {
    className: "logo-link text-sm " + o
  }), e.createElement("div", {
    className: "w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start",
    dangerouslySetInnerHTML: {
      __html: a
    }
  })), e.createElement("div", {
    className: "lg:flex flex-grow items-center hidden"
  }, e.createElement("ul", {
    className: "flex flex-col lg:flex-row list-none lg:ml-auto"
  }, n.map(function (t, a) {
    var l = t.link,
        r = t.text;
    return e.createElement("li", {
      key: a
    }, e.createElement("a", i({}, l, {
      className: "px-3 py-2 flex items-center text-xs font-bold " + o
    }), r));
  })))));
};

P.defaultProps = {
  fixed: !0
};

var j = function j(t) {
  var a = t.title,
      l = t.introText,
      r = t.buttons;
  return e.createElement("section", {
    className: "hero relative pt-16 items-center flex h-screen"
  }, e.createElement("div", {
    className: "container mx-auto items-center flex flex-wrap"
  }, e.createElement("div", {
    className: "w-full md:w-8/12 lg:w-6/12 xl:w-6/12 px-4"
  }, e.createElement("div", {
    className: "pt-32 sm:pt-0"
  }, e.createElement("h1", {
    className: "font-semibold text-4xl text-gray-700"
  }, a), l && e.createElement("p", {
    className: "mt-4 text-lg leading-relaxed text-gray-600",
    dangerouslySetInnerHTML: {
      __html: l
    }
  }), e.createElement("div", {
    className: "mt-12"
  }, null == r ? void 0 : r.map(function (t, a) {
    return e.createElement(b, i({}, t, {
      key: a,
      className: "mr-4"
    }));
  }))))));
},
    C = e.forwardRef(function (t, a) {
  var l = t.src,
      r = t.imageStyle,
      n = void 0 === r ? "simple" : r,
      s = o(t, ["src", "imageStyle"]),
      c = "image max-w-full h-auto align-middle border-none";
  return "simple" === n && (c += "shadow rounded"), "circle" === n && (c += "shadow rounded-full"), "simpleRaised" === n && (c += "shadow-lg rounded"), "circleRaised" === n && (c += "shadow-lg rounded-full"), e.createElement("img", i({
    src: l,
    className: c
  }, s, a));
}),
    _ = e.forwardRef(function (t, a) {
  t.src;
  var l = t.inputSize,
      r = void 0 === l ? "md" : l,
      n = t.placeholder,
      s = o(t, ["src", "inputSize", "placeholder"]),
      c = m("placeholder-gray-400", "text-gray-700", "w-full", "outline-none", "focus:outline-none", "focus:shadow-outline", "relative", "shadow", "rounded", "relative"),
      d = m("input", c, "sm" === r ? ["px-2", "py-1", "text-sm"] : null, "md" === r ? ["px-3", "py-3", "text-sm"] : null, "lg" === r ? ["px-3", "py-4", "text-base"] : null);
  return e.createElement("input", i({
    type: "text",
    placeholder: n,
    className: d
  }, s, a));
});

_.defaultProps = {
  inputSize: "md"
};

var T = function T(t) {
  var a,
      l = t.rounded,
      r = t.variant,
      n = t.uppercase,
      s = t.outline,
      c = o(t, ["rounded", "variant", "uppercase", "outline"]),
      d = m("text-xs", "font-semibold", "inline-block", "py-1", "px-2", "rounded", "text-" + r + "-600", ((a = {
    "rounded-full": l,
    uppercase: n
  })["bg-" + r + "-200"] = !s, a["border-" + r + "-600"] = s, a.border = s, a));
  return e.createElement("span", i({
    className: d
  }, c));
};

T.defaultProps = {
  rounded: !1,
  variant: "red",
  uppercase: !0,
  outline: !1
};

var z = function z(t) {
  var a = t.iconProps,
      l = t.iconColour,
      r = t.title,
      n = t.text;
  return e.createElement("div", {
    className: "lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center"
  }, e.createElement("div", {
    className: "relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg"
  }, e.createElement("div", {
    className: "px-4 py-5 flex-auto"
  }, e.createElement("div", {
    className: "text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-" + l + "-400"
  }, a && e.createElement(d, i({}, a))), e.createElement("h6", {
    className: "text-xl font-semibold"
  }, r), e.createElement("p", {
    className: "mt-2 mb-4 text-gray-600"
  }, n))));
};

z.defaultProps = {
  iconProps: {
    icon: x
  },
  iconColour: "red",
  title: "Verified Company",
  text: "Diam arcu sociis urna enim fames tellus vestibulum curae sagittis urna ut rhoncus odio"
};

var L = Object.freeze({
  __proto__: null,
  Block: z
}),
    R = function R(t) {
  var a = t.variant;
  return e.createElement("div", {
    className: "flex flex-wrap py-2"
  }, e.createElement("div", {
    className: "w-full px-4"
  }, e.createElement("nav", {
    className: "relative flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg bg-" + a + "-500 rounded"
  }, e.createElement("div", {
    className: "container px-4 mx-auto flex flex-wrap items-center justify-between"
  }, e.createElement("div", {
    className: "w-full relative flex justify-between lg:w-auto px-4 lg:static lg:block lg:justify-start"
  }, e.createElement("a", {
    className: "text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-no-wrap uppercase text-white",
    href: "#pablo"
  }, a, " Menu"), e.createElement("button", {
    className: "cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none",
    type: "button"
  }, e.createElement("span", {
    className: "block relative w-6 h-px rounded-sm bg-white"
  }), e.createElement("span", {
    className: "block relative w-6 h-px rounded-sm bg-white mt-1"
  }), e.createElement("span", {
    className: "block relative w-6 h-px rounded-sm bg-white mt-1"
  }))), e.createElement("div", {
    className: "flex lg:flex-grow items-center",
    id: "example-navbar-info"
  }, e.createElement("ul", {
    className: "flex flex-col lg:flex-row list-none ml-auto"
  }, e.createElement("li", {
    className: "nav-item"
  }, e.createElement("a", {
    className: "px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75",
    href: "#pablo"
  }, "Discover")), e.createElement("li", {
    className: "nav-item"
  }, e.createElement("a", {
    className: "px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75",
    href: "#pablo"
  }, "Profile")), e.createElement("li", {
    className: "nav-item"
  }, e.createElement("a", {
    className: "px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75",
    href: "#pablo"
  }, "Settings"))))))));
};

R.defaultProps = {
  variant: "red"
};

var S = function S(t) {
  var a = t.variant;
  return e.createElement("nav", {
    className: "relative flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg bg-" + a + "-500 mb-3"
  }, e.createElement("div", {
    className: "container px-4 mx-auto flex flex-wrap items-center justify-between"
  }, e.createElement("div", {
    className: "w-full relative flex justify-between lg:w-auto  px-4 lg:static lg:block lg:justify-start"
  }, e.createElement("a", {
    className: "text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-no-wrap uppercase text-white",
    href: "#pablo"
  }, a, " Color"), e.createElement("button", {
    className: "cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none",
    type: "button"
  }, e.createElement("span", {
    className: "block relative w-6 h-px rounded-sm bg-white"
  }), e.createElement("span", {
    className: "block relative w-6 h-px rounded-sm bg-white mt-1"
  }), e.createElement("span", {
    className: "block relative w-6 h-px rounded-sm bg-white mt-1"
  }))), e.createElement("div", {
    className: "lg:flex flex-grow items-center",
    id: "example-navbar-arning"
  }, e.createElement("ul", {
    className: "flex flex-col lg:flex-row list-none ml-auto"
  }, e.createElement("li", {
    className: "nav-item"
  }, e.createElement("a", {
    className: "px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75",
    href: "#pablo"
  }, "Discover")), e.createElement("li", {
    className: "nav-item"
  }, e.createElement("a", {
    className: "px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75",
    href: "#pablo"
  }, "Profile")), e.createElement("li", {
    className: "nav-item"
  }, e.createElement("a", {
    className: "px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75",
    href: "#pablo"
  }, "Setting"))))));
};

S.defaultProps = {
  variant: "red"
};

var D = function D(t) {
  var a = t.variant,
      l = t.showPrevAndNext,
      r = t.showFirstAndLast,
      c = t.items,
      d = (t.prevItemProps, t.nextItemProps),
      u = (t.firstItemProps, t.lastItemProps, function (e) {
    var t,
        l = e.active,
        r = e.disabled;
    return m("first:ml-0", "text-xs", "font-semibold", "flex", "w-8", "h-8", "mx-1", "p-0", "rounded-full", "items-center", "justify-center", "leading-tight", "relative", "border", "border-solid", ((t = {})["text-" + a + "-500"] = !l && !r, t["hover:bg-" + a + "-100"] = !l && !r, t["bg-white"] = !l && !r, t["bg-" + a + "-500"] = l && !r, t["text-white"] = l || r, t["border-" + a + "-500"] = !r, t["border-" + a + "-200"] = r, t["bg-" + a + "-200"] = r, t["cursor-not-allowed"] = r, t));
  }),
      p = function p(t) {
    var a = t.type;
    return e.createElement("li", null, e.createElement("a", i({
      className: u({
        active: !1,
        disabled: !1
      })
    }, d), "First" === a && e.createElement(n, {
      className: "-ml-px"
    }), ("Prev" === a || "First" === a) && e.createElement(n, {
      className: "-ml-px"
    }), ("Next" === a || "Last" === a) && e.createElement(s, {
      className: "-mr-px"
    }), "Last" === a && e.createElement(s, {
      className: "-mr-px"
    })));
  };

  return e.createElement("div", {
    className: "py-2"
  }, e.createElement("nav", {
    className: "block"
  }, e.createElement("ul", {
    className: "flex pl-0 rounded list-none flex-wrap"
  }, r && e.createElement(p, {
    type: "First"
  }), l && e.createElement(p, {
    type: "Prev"
  }), null == c ? void 0 : c.map(function (t, a) {
    var l = t.active,
        r = t.disabled,
        n = t.href,
        s = void 0 === n ? "#" : n,
        c = t.onClick,
        m = o(t, ["active", "disabled", "href", "onClick"]);
    return e.createElement("li", {
      key: a
    }, e.createElement("a", i({
      href: s,
      onClick: function onClick(e) {
        return c && (r ? e.preventDefault() : c(e));
      },
      className: u({
        active: l,
        disabled: r
      })
    }, m), a + 1));
  }), l && e.createElement(p, {
    type: "Next"
  }), r && e.createElement(p, {
    type: "Last"
  }))));
};

D.defaultProps = {
  variant: "red",
  items: [{
    active: !0
  }, {}, {}, {}, {}]
};

var F = function F(t) {
  var a = t.bg,
      l = t.badge,
      r = t.percentCompleted,
      n = t.showTopRightPercentCompleted;
  return e.createElement("div", {
    className: "relative pt-1"
  }, (l || r) && e.createElement("div", {
    className: "flex mb-2 items-center justify-between"
  }, l && e.createElement("div", {
    className: "text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-" + a + "-600 bg-" + a + "-200"
  }, l), r && n && e.createElement("div", {
    className: "ml-auto text-right"
  }, e.createElement("span", {
    className: "text-xs font-semibold inline-block text-" + a + "-600"
  }, r, "%"))), e.createElement("div", {
    className: "overflow-hidden h-2 mb-4 text-xs flex rounded bg-" + a + "-200"
  }, r && e.createElement("div", {
    style: {
      width: r + "%"
    },
    className: "shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-" + a + "-500"
  })));
};

F.defaultProps = {
  bg: "red",
  showTopRightPercentCompleted: !1
};

var I = function I(t) {
  var a = t.copyrightName,
      l = t.items;
  return e.createElement("footer", {
    className: "block py-4"
  }, e.createElement("div", {
    className: "container mx-auto px-4"
  }, e.createElement("hr", {
    className: "mb-4 border-b-1 border-gray-300"
  }), e.createElement("div", {
    className: "flex flex-wrap items-center md:justify-between justify-center"
  }, e.createElement("div", {
    className: "w-full md:w-4/12 px-4"
  }, e.createElement("div", {
    className: "text-sm text-gray-600 font-semibold py-1"
  }, "Copyright ", new Date().getFullYear(), " ", a)), e.createElement("div", {
    className: "w-full md:w-8/12 px-4"
  }, e.createElement("ul", {
    className: "flex flex-wrap list-none md:justify-end  justify-center"
  }, null == l ? void 0 : l.map(function (t, a) {
    return e.createElement("li", {
      key: a
    }, e.createElement("a", i({}, t.linkProps, {
      className: "text-gray-700 hover:text-gray-900 text-sm font-semibold block py-1 px-3"
    }), t.text));
  }))))));
};

I.defaultProps = {
  copyrightName: "Rixcy"
};

var B = function B(a) {
  var l = a.buttonText,
      r = a.content,
      n = a.position,
      s = a.title,
      o = a.variant,
      m = c(e.useState(!1), 2),
      d = m[0],
      u = m[1],
      p = t(null),
      x = t(null);
  return e.createElement(e.Fragment, null, e.createElement("div", {
    className: "flex flex-wrap"
  }, e.createElement("div", {
    className: "w-full text-center"
  }, e.createElement("button", {
    className: "bg-" + o + "-500 text-white active:bg-" + o + "-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1",
    type: "button",
    style: {
      transition: "all .15s ease"
    },
    onMouseEnter: function onMouseEnter() {
      new f(p.current, x.current, {
        placement: n
      }), u(!0);
    },
    onMouseLeave: function onMouseLeave() {
      u(!1);
    },
    ref: p
  }, l), e.createElement("div", {
    className: (d ? "" : "hidden") + " bg-" + o + "-600 border-0 m-3 block z-50 font-normal leading-normal text-sm max-w-xs text-left no-underline break-words rounded-lg",
    ref: x
  }, e.createElement("div", null, s && e.createElement(M, i({}, a)), r && e.createElement(A, i({}, a)))))));
};

B.defaultProps = {
  buttonText: "hover me!",
  title: "A really cool tooltip title",
  content: "Fermentum magnis facilisis varius quisque nisl amet",
  position: "right",
  variant: "red"
};

var M = function M(t) {
  var a = t.variant,
      l = t.title;
  return e.createElement("div", {
    className: "bg-" + a + "-600 text-white opacity-75 font-semibold p-3 mb-0 border-b border-solid border-gray-200 uppercase rounded-t-lg"
  }, l);
},
    A = function A(t) {
  var a = t.content;
  return e.createElement("div", {
    className: "text-white p-3"
  }, a);
};

export { v as Alert, k as BottomNav, b as Button, h as Dashboard, N as Dropdown, y as Footer, P as Header, j as Hero, C as Image, _ as Input, T as Label, L as Landing, R as Menu, S as Navbar, D as Pagination, F as ProgressBar, I as SimpleFooter, B as Tooltip, A as TooltipContent, M as TooltipTitle };